import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface B2cAnalyticsSummary {
  visitors: number; sessions: number; rawVisitors: number; rawSessions: number;
  activeSeconds: number; pageViews: number;
  searches: number; emptySearches: number; cartChanges: number; checkouts: number;
  orders: number; orderValue: number; contacts: number; registrations: number;
  vinLookups: number; uniqueVins: number;
  topPages: Array<{ path: string; views: number; activeSeconds: number }>;
  geography: Array<{ country: string; city: string; visitors: number }>;
  trafficSources: Array<{
    source: 'google_ads' | 'google_organic' | 'google_unattributed' | 'direct' | 'other_campaign' | 'referral';
    sessions: number; visitors: number; productSessions: number; cartSessions: number;
    checkoutSessions: number; orders: number; orderValue: number;
  }>;
}
export interface B2cAnalyticsVisitor {
  id: number; visitorId: string; accountId: number | null; name: string | null;
  surname: string | null; phone: string | null; country: string | null; city: string | null;
  firstSeenAt: string; lastSeenAt: string; cartItems: number; cartTotal: number;
  vinLookups: number; uniqueVins: number;
}
export interface B2cSearchQuery {
  query: string; lastAt: string; attempts: number; noResults: boolean;
  visitorDbId: number | null; visitorId: string | null; accountId: number | null;
  name: string | null; surname: string | null; phone: string | null;
}
export interface B2cRegistration {
  id: number; createdAt: string; lastLoginAt: string | null; name: string; surname: string | null;
  phone: string; email: string | null; clientId: number; vinLookups: number; uniqueVins: number;
  cartItems: number; hasOrders: boolean;
}

@Injectable({ providedIn: 'root' })
export class B2cAnalyticsService {
  constructor(private http: HttpClient) {}
  summary(from: string, to: string) {
    return this.http.get<B2cAnalyticsSummary>(`${environment.BACKEND}/b2c-analytics/summary`, {
      params: { from, to }
    });
  }
  visitors(from: string, to: string, filters: {
    registered?: string; hasCart?: string; search?: string; location?: string; event?: string;
  } = {}) {
    let params = new HttpParams().set('from', from).set('to', to).set('limit', '100');
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') params = params.set(key, value);
    });
    return this.http.get<{ items: B2cAnalyticsVisitor[]; count: number }>(
      `${environment.BACKEND}/b2c-analytics/visitors`, { params }
    );
  }
  visitor(id: number) {
    return this.http.get<any>(`${environment.BACKEND}/b2c-analytics/visitors/${id}`);
  }
  searches(from: string, to: string, filters: { hasResults?: string } = {}) {
    let params = new HttpParams().set('from', from).set('to', to).set('limit', '100');
    if (filters.hasResults) params = params.set('hasResults', filters.hasResults);
    return this.http.get<{ items: B2cSearchQuery[]; count: number }>(
      `${environment.BACKEND}/b2c-analytics/searches`, { params }
    );
  }
  registrations(from: string, to: string) {
    return this.http.get<{ items: B2cRegistration[]; count: number }>(
      `${environment.BACKEND}/b2c-analytics/registrations`, { params: { from, to, limit: 100 } }
    );
  }
}
